import {
  couponColumns,
  couponCsvOrderColumns,
  getCouponCellValue,
} from './couponReportColumns';

const escapeCsvValue = (value) => {
  if (value === null || value === undefined) {
    return '';
  }
  const stringValue = String(value);
  return /[",\n]/.test(stringValue)
    ? `"${stringValue.replace(/"/g, '""')}"`
    : stringValue;
};

export const buildCouponReportCsv = (reportList, labels) => {
  const buildLine = (row, columns) =>
    columns
      .map((column) => escapeCsvValue(getCouponCellValue(row, column, labels)))
      .join(',');

  const buildHeader = (columns) =>
    columns.map((column) => escapeCsvValue(labels.t(column.label))).join(',');

  const couponLines = reportList.map((coupon) =>
    buildLine(coupon, couponColumns)
  );

  const orderLines = reportList.flatMap((coupon) =>
    (coupon.orders || []).map((order) =>
      buildLine(
        { ...order, coupon_code: coupon.coupon_code },
        couponCsvOrderColumns
      )
    )
  );

  return [
    buildHeader(couponColumns),
    ...couponLines,
    '',
    buildHeader(couponCsvOrderColumns),
    ...orderLines,
  ].join('\n');
};

export const exportCouponReportCsv = (reportList, labels, fileName) => {
  const csv = buildCouponReportCsv(reportList, labels);
  const blob = new Blob([csv], { type: 'text/csv' });
  const a = window.document.createElement('a');
  a.href = window.URL.createObjectURL(blob);
  a.download = `${fileName}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(a.href);
};
